import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	() => ({
		content: {
			alignItems: 'start',
		},
		buttonWrap: {
			justifyContent: 'start',
		},
	}),
	{ name: 'CallToAction-Cta7' },
)

export default useStyles
